jQuery(document).ready(function ($) {
    console.log("interactive parts");

    let partFlyoutWrapper = $(".interactive__part--spotlight--wrapper");

    $(".interactive__part--spotlight--close").on("click", function (e) {
        partFlyoutWrapper.removeClass("show");
    });

    $('[data-toggle="marker"]').each(function () {
        $(this).on("click", function (e) {
            e.preventDefault();

            let anchor = $(this).data("anchor");
            let label = $(this).data("label");
            let parts = $(this).data("parts");

            $.ajax({
                method: "POST",
                url: TG.ajaxUrl,
                data: {
                    action: "getFlyoutPartData",
                    anchor,
                    label,
                    parts,
                },
                success: flyoutSuccess,
                error: flyoutError,
            });
        });
    });

    function flyoutError(response) {
        console.log("fail!");
        console.error(response);
    }

    function flyoutSuccess(response) {
        // console.log("success!");
        // console.log(response.data);

        if (!partFlyoutWrapper.hasClass("show")) {
            partFlyoutWrapper.addClass("show");
        }

        let partFlyoutTable = $("#partFlyout .interactive__part--row--body");
        let partData = response.data;

        // console.log(partFlyoutTable);
        // let partFlyoutTableRow = partFlyoutTable.attr("id");
        // console.log(partFlyoutTableRow);
        // console.log(partData.anchor);
        $(partFlyoutTable).replaceWith(partData.parthtml);
    }
});
